
import Hero from "@/components/Hero";

const Terms = () => {
  return (
    <div className="fade-in">
      <Hero 
        title="Müügitingimused"
        subtitle="Elevoria OÜ müügitingimused"
        buttonText="Küsi lisainfot"
        buttonLink="/contact"
        bgColor="bg-gradient-to-r from-kaija-peach to-kaija-light"
      />
      
      <section className="section-padding bg-white">
        <div className="container-custom max-w-4xl mx-auto">
          <div className="prose prose-lg mx-auto space-y-8">
            <div className="w-20 h-1 bg-kaija-accent rounded-full mx-auto mb-10"></div>
            
            <div className="mb-8">
              <p className="text-center font-medium text-xl">Elevoria OÜ</p>
              <p className="text-center text-gray-600">Kehtivad alates 05. märts 2025</p>
            </div>

            <div className="bg-gradient-to-br from-kaija-pink/30 to-transparent p-8 rounded-lg shadow-sm">
              <h2 className="text-xl md:text-2xl font-medium mb-4">1. Üldinfo</h2>
              <p className="mb-3">1.1. Käesolevad müügitingimused (edaspidi "Tingimused") reguleerivad Elevoria OÜ (registrikood 17129519, aadress Harju maakond, Harku vald, Tiskre küla, Välja tee 19/1-1, 76916, e-post kaija@kaijaalliksaar.ee, edaspidi "Müüja") ja ostja (edaspidi "Klient") vahelisi õigussuhteid, mis tekivad seoses digitaalse sisu ostmisega Müüja veebilehelt https://www.kaijaalliksaar.ee.</p>
              <p className="mb-3">1.2. Müüja pakub Klientidele digitaalset sisu, milleks on koolitusvideod (voogedastusvormis, mitte allalaetavad) ja allalaetavad lisamaterjalid (nt PDF-failid).</p>
              <p>1.3. Tingimustega nõustumine on ostu sooritamise eeltingimus. Ostu sooritamisega kinnitab Klient, et on Tingimustega tutvunud ja nõustunud.</p>
            </div>
            
            <div className="bg-gradient-to-br from-kaija-pink/30 to-transparent p-8 rounded-lg shadow-sm">
              <h2 className="text-xl md:text-2xl font-medium mb-4">2. Toote kirjeldus</h2>
              <p className="mb-3">2.1. Müüja pakub järgmisi tooteid:</p>
              <div className="pl-6 mb-4">
                <p className="mb-2"><strong>Koolitusvideod:</strong> Digitaalne sisu voogedastusvormis, mis on kättesaadav veebipõhiselt. Videod ei ole allalaetavad ning nende vaatamise õigus kehtib 6 kuud alates ostu sooritamise kuupäevast.</p>
                <p><strong>Lisamaterjalid:</strong> Allalaetavad failid (nt PDF-formaadis dokumendid), mis on kättesaadavad Kliendile peale ostu sooritamist.</p>
              </div>
              <p>2.2. Toote täpne sisu, hind ja muud detailid on toodud veebilehel toote kirjelduses ostuhetkel.</p>
            </div>
            
            <div className="bg-gradient-to-br from-kaija-pink/30 to-transparent p-8 rounded-lg shadow-sm">
              <h2 className="text-xl md:text-2xl font-medium mb-4">3. Ostuprotsess</h2>
              <p className="mb-3">3.1. Klient valib veebilehel soovitud toote ja lisab selle ostukorvi.</p>
              <p className="mb-3">3.2. Ostu vormistamiseks täidab Klient nõutud andmeväljad (nt nimi, e-post) ning valib makseviisi.</p>
              <p className="mb-3">3.3. Pärast makse sooritamist saab Klient e-posti teel kinnituse ostu kohta ning juurdepääsu digitaalsele sisule vastavalt Tingimustele.</p>
              <p>3.4. Müüja jätab endale õiguse keelduda ostust, kui Klient rikub Tingimusi või esitab valeandmeid.</p>
            </div>
            
            <div className="bg-gradient-to-br from-kaija-pink/30 to-transparent p-8 rounded-lg shadow-sm">
              <h2 className="text-xl md:text-2xl font-medium mb-4">4. Hind ja maksmine</h2>
              <p className="mb-3">4.1. Kõik hinnad on toodud eurodes (€).</p>
              <p className="mb-3">4.2. Maksmine toimub Müüja poolt pakutavate makseviiside kaudu (nt Montonio pangalingid, kaardimaksed). Maksete töötlemise eest vastutab kolmas osapool (makseteenuse pakkuja).</p>
              <p>4.3. Peale makse laekumist väljastab Müüja Kliendile arve e-posti teel.</p>
            </div>
            
            <div className="bg-gradient-to-br from-kaija-pink/30 to-transparent p-8 rounded-lg shadow-sm">
              <h2 className="text-xl md:text-2xl font-medium mb-4">5. Juurdepääs digitaalsele sisule</h2>
              <p className="mb-3">5.1. Koolitusvideod tehakse Kliendile kättesaadavaks veebipõhise voogedastuse kaudu. Juurdepääs videotele kehtib 6 kuud alates ostu kuupäevast, peale mida juurdepääs lõpeb automaatselt.</p>
              <p className="mb-3">5.2. Lisamaterjalid (nt PDF-failid) on Kliendile allalaetavad peale ostu sooritamist Müüja veebilehe kontoalas ("Minu konto") või ostukinnitusega saadetud lingi kaudu.</p>
              <p>5.3. Klient kohustub mitte jagama, kopeerima ega levitama ostetud digitaalset sisu kolmandatele osapooltele. Sisu on mõeldud ainult Kliendi isiklikuks kasutamiseks.</p>
            </div>
            
            <div className="bg-gradient-to-br from-kaija-pink/30 to-transparent p-8 rounded-lg shadow-sm">
              <h2 className="text-xl md:text-2xl font-medium mb-4">6. Taganemisõigus</h2>
              <p className="mb-3">6.1. Kuna tegemist on digitaalse sisuga, mis tehakse Kliendile kättesaadavaks kohe peale ostu, ei kohaldu 14-päevane taganemisõigus vastavalt Eesti Vabariigi Võlaõigusseaduse § 53 lg 4 p 4-le, kui Klient on andnud selleks eelneva nõusoleku ja kinnitanud, et on teadlik taganemisõiguse kaotamisest.</p>
              <p>6.2. Klient kinnitab ostu vormistamisel, et nõustub digitaalse sisu kohese kättesaamisega ja taganemisõiguse kaotamisega.</p>
            </div>
            
            <div className="bg-gradient-to-br from-kaija-pink/30 to-transparent p-8 rounded-lg shadow-sm">
              <h2 className="text-xl md:text-2xl font-medium mb-4">7. Intellektuaalomand</h2>
              <p className="mb-3">7.1. Kõik koolitusvideod ja lisamaterjalid on Elevoria OÜ intellektuaalomand ning kaitstud autoriõigustega.</p>
              <p>7.2. Kliendil on õigus kasutada sisu isiklikuks otstarbeks, kuid keelatud on selle reprodutseerimine, levitamine või muul viisil äriline kasutamine ilma Müüja kirjaliku nõusolekuta.</p>
            </div>
            
            <div className="bg-gradient-to-br from-kaija-pink/30 to-transparent p-8 rounded-lg shadow-sm">
              <h2 className="text-xl md:text-2xl font-medium mb-4">8. Vastutus</h2>
              <p className="mb-3">8.1. Müüja vastutab digitaalse sisu kättesaadavuse eest vastavalt Tingimustele. Müüja ei vastuta tehniliste tõrgete eest, mis tulenevad Kliendi seadmetest või internetiühendusest.</p>
              <p>8.2. Klient vastutab oma konto turvalisuse eest ning kohustub teavitama Müüjat viivitamatult, kui kahtlustab volitamata juurdepääsu.</p>
            </div>
            
            <div className="bg-gradient-to-br from-kaija-pink/30 to-transparent p-8 rounded-lg shadow-sm">
              <h2 className="text-xl md:text-2xl font-medium mb-4">9. Pretensioonid ja vaidlused</h2>
              <p className="mb-3">9.1. Kliendil on õigus esitada pretensioone digitaalse sisu kohta 14 päeva jooksul alates ostu sooritamisest, saates kirjaliku teate aadressile kaija@kaijaalliksaar.ee.</p>
              <p className="mb-3">9.2. Müüja vastab pretensioonile 14 päeva jooksul. Kui vaidlust ei lahendata läbirääkimiste teel, lahendatakse see Eesti Vabariigi seaduste kohaselt Harju Maakohtus.</p>
              <p>9.3. Klient võib tarbijavaidluse korral pöörduda Tarbijakaitse ja Tehnilise Järelevalve Ameti poole (www.ttja.ee).</p>
            </div>
            
            <div className="bg-gradient-to-br from-kaija-pink/30 to-transparent p-8 rounded-lg shadow-sm">
              <h2 className="text-xl md:text-2xl font-medium mb-4">10. Tingimuste muutmine</h2>
              <p>10.1. Müüjal on õigus Tingimusi ühepoolselt muuta, teavitades Kliente muudatustest veebilehel vähemalt 14 päeva ette. Muudatused ei mõjuta juba sooritatud oste.</p>
            </div>
            
            <div className="bg-gradient-to-br from-kaija-pink/30 to-transparent p-8 rounded-lg shadow-sm">
              <h2 className="text-xl md:text-2xl font-medium mb-4">11. Kontaktandmed</h2>
              <div>
                <p className="mb-1"><strong>Elevoria OÜ</strong></p>
                <p className="mb-1">Registrikood: 17129519</p>
                <p className="mb-1">Aadress: Harju maakond, Harku vald, Tiskre küla, Välja tee 19/1-1, 76916</p>
                <p>E-post: kaija@kaijaalliksaar.ee</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
